import { observable } from "micro-observables";
import { BaseExercise } from "@domain/exercise/exercise";
import { ExerciseService } from "@domain/exercise/exercise-service";
import { orderList } from "@utils/string-utils";

export enum ExerciseFetchState {
    Undefined,
    Available,
    Loading,
    Error,
}

export class ExerciseManager {
    private readonly _exercisesStatus = observable<ExerciseFetchState>(ExerciseFetchState.Undefined);
    public exercisesStatus = this._exercisesStatus.readOnly();

    private readonly _exercises = observable<BaseExercise[]>([]);
    public allExercises = this._exercises.readOnly();

	private readonly _exerciseTotalCount = observable<number>(0);
	exerciseTotalCount = this._exerciseTotalCount.readOnly();

    constructor(private readonly exerciseService: ExerciseService) {
		this.exerciseTotalCount = this._exercises.select(exercises => exercises.length);
    }

    async fetchExercises(): Promise<void> {
        this._exercisesStatus.set(ExerciseFetchState.Loading);

        try {
            const exercises = await this.exerciseService.listExercises();
            this._exercisesStatus.set(ExerciseFetchState.Available);
            this._exercises.set(orderList(exercises, "title"));
            this._exerciseTotalCount.set(this._exercises.get().length);
        } catch (e) {
            this._exercisesStatus.set(ExerciseFetchState.Error);
            throw e;
        }
    }
}